import FontAwesomeProIcon from '../FontAwesome/FontAwesomeProIcon';
import Card from 'wienenergiedesignsystem/components/Card/Card';
import styles from 'wienenergiedesignsystem/components/Modal/Modal.module.scss';
import classNames from 'classnames';
import React from 'react';
import { Dialog, DialogBackdrop } from 'reakit/Dialog';
import { Button } from 'reakit/Button';
import { usePreventScroll } from 'wienenergiedesignsystem/hooks/usePreventScroll';

var Modal = function Modal(_ref) {
  var _classNames, _classNames2, _classNames3, _classNames4, _classNames5;

  var dialog = _ref.dialog,
      header = _ref.header,
      children = _ref.children,
      theme = _ref.theme,
      scrollDisabled = _ref.scrollDisabled,
      contentClassName = _ref.contentClassName,
      i18n = _ref.i18n,
      actions = _ref.actions,
      size = _ref.size,
      hideOnClickOutside = _ref.hideOnClickOutside,
      tabIndex = _ref.tabIndex,
      finalFocusRef = _ref.finalFocusRef,
      className = _ref.className,
      onClose = _ref.onClose;
  usePreventScroll(dialog.visible);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogBackdrop, Object.assign({}, dialog, {
    className: classNames(styles.backdrop, (_classNames = {}, _classNames[styles.animated] = dialog.animated, _classNames))
  }), /*#__PURE__*/React.createElement(Dialog, Object.assign({}, dialog, {
    preventBodyScroll: false // disable built-in preventBodyScroll from reakit
    ,
    "aria-label": i18n.dialog,
    hideOnClickOutside: hideOnClickOutside,
    tabIndex: tabIndex || undefined,
    unstable_finalFocusRef: finalFocusRef,
    className: classNames(styles.dialog, (_classNames2 = {}, _classNames2[styles.animated] = dialog.animated, _classNames2))
  }), /*#__PURE__*/React.createElement(Card, {
    className: classNames(styles.card, (_classNames3 = {}, _classNames3[styles.large] = size === 'lg', _classNames3), className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.header, styles[theme], (_classNames4 = {}, _classNames4[styles.withClose] = !actions, _classNames4))
  }, header, !actions && /*#__PURE__*/React.createElement(Button, {
    className: styles.close,
    onClick: onClose || dialog.hide,
    as: "div",
    "aria-label": "Dialog schlie\xDFen"
  }, /*#__PURE__*/React.createElement(FontAwesomeProIcon, {
    type: "solid",
    icon: "times",
    role: "presentation"
  })), actions && /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, actions)), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.content, contentClassName, (_classNames5 = {}, _classNames5[styles.scrollDisabled] = scrollDisabled, _classNames5))
  }, children)))));
};

Modal.defaultProps = {
  i18n: {
    dialog: 'Modal'
  },
  size: null,
  theme: 'default',
  hideOnClickOutside: true,
  tabIndex: null
};
export { Modal as default };